<template>
    <div class="flex flex-col w-full h-full text-highlighted">
        <template v-if="sender">
            <div>{{ sender.name }}</div>
            <div class="mb-4">{{ sender.orgNo }}</div>
        </template>
        <div class="grid grid-cols-3 gap-4 mb-4">
            <key-value v-if="ehfData.invoiceNo" name="Fakturanummer" :value="ehfData.invoiceNo"/>
            <key-value v-if="ehfData.customer.reference" name="Kunderef." :value="ehfData.customer.reference"/>
            <key-value v-if="ehfData.customerIdentification" name="KID" :value="ehfData.customerIdentification"/>
            <key-value v-if="ehfData.date" name="Fakturadato" :value="formattedDate(ehfData.date)"/>
            <key-value v-if="ehfData.dueDate" name="Forfallsdato" :value="formattedDate(ehfData.dueDate)"/>
            <key-value v-if="ehfData.bankAccount" name="Bankkonto" :value="ehfData.bankAccount"/>
            <key-value v-if="ehfData.grossAmount" name="Bruttobeløp" :value="ehfData.grossAmount"/>
            <key-value v-if="ehfData.netAmount" name="Nettobeløp" :value="ehfData.netAmount"/>
            <key-value v-if="ehfData.deliveryLocation.postalCode" name="Leveringssted" :value="ehfData.deliveryLocation.postalCode"/>
        </div>

        <div class="border border-default rounded-lg border-b-none text-sm overflow-x-auto">
            <div class="min-w-[400px]">
                <div class="grid grid-cols-6 text-center bg-gray-50 p-2 border-b border-default">
                    <div class="col-span-2 text-left">Produkt</div>
                    <div>Antall</div>
                    <div>Enhetspris</div>
                    <div>Avslag</div>
                    <div>MVA</div>
                </div>
                <div
                    v-for="(item, index) in json.invoiceLines"
                    :key="index"
                    :class="index === json.invoiceLines.length - 1 ? 'border-b-none' : 'border-b'"
                    class="grid grid-cols-6 border-default items-center p-2 text-center"
                >
                    <div class="text-left col-span-2">{{ item.name }}</div>
                    <div>{{ item.quantity }}</div>
                    <div>{{ formatCurrency(item.unitPrice) }}</div>
                    <div>{{ item.discount * 100 }}%</div>
                    <div>{{ item.vatRate * 100 }}%</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

import {computed} from 'vue'
import KeyValue from '@/components/KeyValue.vue'
import {formatCurrency, formattedDate} from '@/services/formatter.service'

const props = defineProps({
    json: {
        type: Object as any,
        required: true
    }
})

const ehfData = computed(() => {
    return props.json
})

const sender = computed(() => {
    return ehfData.value.sender
})

</script>

<style scoped>

</style>